var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuxembourg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 40C31.0458 40 40.0001 31.0457 40.0001 20C40.0001 8.9543 31.0458 0 20.0001 0C8.95437 0 6.10352e-05 8.9543 6.10352e-05 20C6.10352e-05 31.0457 8.95437 40 20.0001 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 0C11.4006 0 4.06976 5.4275 1.2439 13.0435H38.756C35.9301 5.4275 28.5992 0 19.9999 0V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 40.0001C28.5992 40.0001 35.9301 34.5726 38.7559 26.9565H1.2439C4.06976 34.5726 11.4006 40.0001 19.9999 40.0001Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuxembourg);
export default __webpack_public_path__ + "static/media/luxembourg.bfbb79699660f5ce9480350611bf8bed.svg";
export { ForwardRef as ReactComponent };